import { useLayoutEffect, useEffect } from 'react';

// cc https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect as default };
//# sourceMappingURL=useIsomorphicLayoutEffect.mjs.map
